<template>
  <div>
    <UIBlocker :isShow="isLoading"> Carregando... </UIBlocker>
    <b-form-row>
      <b-col class="mb-2">
        <b-button @click="showResumo" size="sm" variant="success"
          ><i class="fas fa-sync"></i> Atualizar Lista</b-button
        >
        <b-button class="ml-2" @click="deleteAll" size="sm" variant="danger"
          ><i class="fas fa-sync"></i> Excluir Tudo</b-button
        >
        <b-button
          class="ml-2"
          @click="doRedistribuir"
          size="sm"
          variant="warning"
          ><i class="fas fa-sync"></i> Redistribuir</b-button
        >
        <b-button
          @click="doShowPlanejOriginal()"
          class="ml-2"
          size="sm"
          variant="primary"
          >Planej. Original</b-button
        >
        <b-button
          @click="doAddResumo()"
          class="float-right"
          size="sm"
          variant="success"
          ><i class="fas fa-plus"></i> Adicionar</b-button
        >
        <b-button
          @click="doShowGerarInicial()"
          class="float-right mr-2"
          size="sm"
          variant="success"
          >Gerar Planejamento Inicial</b-button
        >
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-checkbox
          class="ml-3"
          inline
          size="sm"
          v-model="exibirCampos"
          :value="true"
          :unchecked-value="false"
        >
          Planejado Original
        </b-checkbox>
        <b-checkbox
          class="ml-3"
          inline
          size="sm"
          v-model="exibir2aMoeda"
          :value="true"
          :unchecked-value="false"
          @change="showResumo()"
        >
          2ª Moeda ({{ wbs.moeda == null ? "" : wbs.moeda.sigla }})
        </b-checkbox>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-table
          hover
          bordered
          small
          responsive
          striped
          primary-key="planejamento_id"
          table-class="font08 table-border"
          thead-class="table-header"
          selectable
          select-mode="single"
          selected-variant="primary"
          head-variant="dark"
          empty-text="Sem dados para exibir"
          empty-filtered-text="Sem dados para exibir"
          show-empty
          :fields="visibleFields"
          :items="resumo"
          :tbody-tr-class="rowClass"
        >
          <template #thead-top="">
            <b-tr class="top-header">
              <b-th :colspan="exibirCampos ? 7 : 6">PLANEJAMENTO/EXECUÇÃO</b-th>
              <b-th :colspan="exibirCampos ? 11 : 10">ACUMULADO</b-th>
              <b-th :colspan="2"></b-th>
            </b-tr>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(mes_ano)="data">
            {{
              `${String(data.item.mes_planejamento).padStart(2, "0")}/${
                data.item.ano_planejamento
              }`
            }}
          </template>
          <template v-slot:cell(entidade)="data">
            <span v-if="data.item.ind_entidade_pagto == 1">BID</span>
            <span v-if="data.item.ind_entidade_pagto == 2">ESTADO</span>
            <span v-if="data.item.ind_entidade_pagto == 3">BID/ESTADO</span>
          </template>

          <template v-slot:cell(acoes)="data">
            <b-button
              v-if="(parseFloat(data.item.vl_medido) || 0) === 0"
              size="sm"
              class="btn-xs"
              variant="primary"
              @click="editResumo(data.item)"
              title="Alterar"
              ><i class="fas fa-edit"></i
            ></b-button>
            <b-button
              v-if="(parseFloat(data.item.vl_medido) || 0) === 0"
              size="sm"
              class="btn-xs"
              variant="danger"
              @click="deleteResumo(data.item)"
              title="Excluir"
              ><i class="fas fa-trash"></i
            ></b-button>
            <b-button
              size="sm"
              class="btn-xs"
              variant="secondary"
              @click="showObsResumo(data.item)"
              title="Ver Observações"
              ><i class="far fa-comments"></i
            ></b-button>
          </template>
        </b-table>
      </b-col>
    </b-form-row>
    <b-modal
      title="Gerar Inicial"
      id="modal-gerar-inicial"
      no-close-on-backdrop
      no-close-on-esc
      no-fade
    >
      <b-form-row>
        <b-col>
          <b-form-group label-size="sm" label="Valor do Contrato R$">
            <b-form-input
              size="sm"
              disabled
              class="text-right"
              :value="vlInicialContratoFormatado"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group label-size="sm" label="Qtde Meses">
            <b-form-input
              :state="inicial.meses > 0 ? null : false"
              type="number"
              min="1"
              max="9999"
              step="1"
              class="text-right"
              size="sm"
              aria-describedby="input-live-feedback"
              v-model="inicial.meses"
            ></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Deve ser maior que 0
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-size="sm" label="Data da 1ª Medição">
            <date-picker
              id="dt_termino"
              input-class="form-control form-control-sm"
              :clearable="false"
              maxlength="10"
              format="DD/MM/YYYY"
              value-type="YYYY-MM-DD"
              v-model="inicial.data1"
            ></date-picker>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group label-size="sm" label="Valor da Medição R$">
            <b-form-input
              class="text-right"
              size="sm"
              disabled
              :value="resumoCalculado"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-size="sm" label="Data da Última Medição">
            <b-form-input
              class="text-right"
              size="sm"
              disabled
              :value="dataUltimoResumo"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button
          :disabled="inicialValido"
          size="sm"
          @click="doGerarInicial()"
          variant="primary"
        >
          <i class="fas fa-check"></i> Gerar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-gerar-inicial')"
          >Fechar</b-button
        >
      </template>
    </b-modal>
    <b-modal
      title="Observações"
      id="modal-obs-resumo"
      no-close-on-backdrop
      no-close-on-esc
      no-fade
      size="lg"
    >
      <b-form-row>
        <b-col>
          <b-form-textarea
            size="sm"
            disabled
            :value="registro.observacoes"
            rows="20"
            no-resize
          ></b-form-textarea>
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="() => $bvModal.hide('modal-obs-resumo')"
          >Fechar</b-button
        >
      </template>
    </b-modal>
    <ModalResumo
      :registro="registro"
      :acao="acaoRegistro"
      @updateResumo="showResumo"
    />
    <modal-planej-original :wbs="wbs"></modal-planej-original>
    <UIBlocker :isShow="isRedistributing">
      Redistribuindo Valores. Aguarde...
    </UIBlocker>
  </div>
</template>

<script>
import { formatMoney, validateDate } from "@/global";
import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

import axios from "axios";
import { baseApiUrl, showError } from "@/global";
import { bidbus } from "@/main";
import ModalResumo from "./ModalResumo";

import UIBlocker from "@/components/layout/UIBlocker";
import ModalPlanejOriginal from "./ModalPlanejOriginal.vue";

const resumoModel = () => {
  return {
    resumo_id: 0,
    dt_faturamento: moment().format("DD/MM/YYYY"),
    mes_planejamento: moment().format("MM"),
    ano_planejamento: moment().format("YYYY"),
    vl_planejado: 0,
    vl_pago: 0,
    vl_reconhecido: 0,
    vl_saldo: 0,
    vl_planejado_ac: 0,
    vl_pago_ac: 0,
    vl_reconhecido_ac: 0,
    vl_saldo_ac: 0,
    observacoes: "",
    ind_entidade_pagto: 1,
  };
};

export default {
  name: "SubTabResumoFinanceiro",
  components: { DatePicker, ModalResumo, UIBlocker, ModalPlanejOriginal },
  computed: {
    visibleFields() {
      let _fields = this.campos;
      if (!this.exibirCampos)
        _fields = _fields.filter(
          (field) =>
            field.key != "vl_planejado_orig" &&
            field.key != "vl_planejado_orig_ac" &&
            field.key != "vl_planejado_orig_m2_ac" &&
            field.key != "vl_planejado_orig_m2"
        );

      if (!this.exibir2aMoeda)
        _fields = _fields.filter((field) => field.key.indexOf("_m2") == -1);
      else {
        _fields = _fields.filter(
          (field) =>
            field.key != "vl_reconhecido" &&
            field.key != "vl_planejado" &&
            field.key != "vl_planejado_orig" &&
            field.key != "vl_planejado_orig_ac" &&
            field.key != "vl_reconhecido_ac" &&
            field.key != "vl_pago_ac" &&
            field.key != "vl_pago_ac" &&
            field.key != "vl_pago" &&
            field.key != "vl_planejado_ac" &&
            field.key != "vl_saldo_pagar_ac" &&
            field.key != "vl_saldo_reconhecer_ac" &&
            field.key != "vl_medido" &&
            field.key != "vl_medido_ac"
        );
      }

      return _fields;
    },
    inicialValido: {
      get() {
        return !(
          (this.wbs.vl_inicial_contrato > 0 ||
            this.wbs.vl_total_reajustes > 0 ||
            this.wbs.vl_estimado_licitacao > 0) &&
          this.inicial.meses > 0 &&
          validateDate(this.inicial.data1, "YYYY-MM-DD")
        );
      },
    },
    dataUltimoResumo: {
      get() {
        if (!validateDate(this.inicial.data1, "YYYY-MM-DD")) return "";
        else
          return moment(this.inicial.data1, "YYYY-MM-DD")
            .add(this.inicial.meses, "months")
            .format("DD/MM/YYYY");
      },
    },
    resumoCalculado: {
      get() {
        return formatMoney(
          parseFloat(this.wbs.vl_inicial_contrato) /
            parseInt(this.inicial.meses == 0 ? 1 : this.inicial.meses),
          2,
          "",
          ".",
          ","
        );
      },
    },
    vlInicialContratoFormatado: {
      get() {
        let _valor = this.wbs.vl_total_reajustes || 0;
        if (_valor == 0) _valor = this.wbs.vl_inicial_contrato || 0;
        if (_valor == 0) _valor = this.wbs.vl_estimado_licitacao || 0;
        return formatMoney(_valor, 2, "", ".", ",");
      },
    },
  },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  data: function() {
    return {
      isLoading: false,
      isRedistributing: false,
      exibir2aMoeda: false,
      exibirCampos: false,
      registro: new resumoModel(),
      acaoRegistro: "alterar",
      inicial: {
        meses: Math.ceil(this.wbs.prazo_inicial_dias / 30),
        data1: moment().format("DD/MM/YYYY"),
      },
      resumo: [],
      campos: [
        {
          key: "index",
          label: "#",
          class: "w40-field",
        },
        { key: "mes_ano", label: "Mês/Ano", class: "w100-field" },
        {
          key: "vl_planejado_orig",
          class: "text-right w100-field",
          label: "Planej. Orig. R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_planejado_orig_m2",
          class: "text-right w100-field",
          label: "Planej. Orig. 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_planejado",
          class: "text-right w100-field",
          label: "Planejado R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_planejado_m2",
          class: "text-right w100-field",
          label: "Planejado 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_medido",
          class: "text-right w100-field",
          label: "Medido R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_medido_m2",
          class: "text-right w100-field",
          label: "Medido 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_pago",
          class: "text-right w100-field",
          label: "Pago R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },

        {
          key: "vl_pago_m2",
          class: "text-right w100-field",
          label: "Pago 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_reconhecido",
          class: "text-right w100-field",
          label: "Reconhecido R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_reconhecido_m2",
          class: "text-right w100-field",
          label: "Reconhecido 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },

        {
          key: "vl_planejado_orig_ac",
          class: "accum-col text-right  w100-field",
          label: "Planej. Orig. R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_planejado_orig_m2_ac",
          class: "accum-col text-right  w100-field",
          label: "Planejado Orig. 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },

        {
          key: "vl_planejado_ac",
          class: "accum-col text-right w100-field",
          label: "Planejado R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_planejado_m2_ac",
          class: "accum-col text-right w100-field",
          label: "Planejado 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "perc_planejado_ac",
          class: "accum-col text-right w100-field",
          label: "%",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",") + "%";
          },
        },
        {
          key: "vl_medido_ac",
          class: "accum-col text-right w100-field",
          label: "Medido R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_medido_m2_ac",
          class: "accum-col text-right w100-field",
          label: "Medido 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "perc_medido_ac",
          class: "accum-col text-right w100-field",
          label: "%",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",") + "%";
          },
        },
        {
          key: "vl_pago_ac",
          class: "accum-col text-right w100-field",
          label: "Pago R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_pago_m2_ac",
          class: "accum-col text-right w100-field",
          label: "Pago 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "perc_pago_ac",
          class: "accum-col text-right w100-field",
          label: "%",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",") + "%";
          },
        },

        {
          key: "vl_reconhecido_ac",
          class: "accum-col text-right w100-field",
          label: "Reconhecido R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_reconhecido_m2_ac",
          class: "text-right w100-field",
          label: "Reconhecido 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "perc_reconhecido_ac",
          class: "accum-col text-right w100-field",
          label: "%",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",") + "%";
          },
        },

        {
          key: "vl_saldo_pagar_m2_ac",
          class: "accum-col text-right w100-field",
          label: "Saldo a Pagar 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_saldo_pagar_ac",
          class: "accum-col text-right w100-field",
          label: "Saldo a Pagar R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_saldo_reconhecer_m2_ac",
          class: "accum-col text-right w100-field",
          label: "Saldo a Reconhecer 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_saldo_reconhecer_ac",
          class: "accum-col text-right w100-field",
          label: "Saldo a Reconhecer R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        { key: "entidade", label: "Entidade de Pagto", class: "w120-field" },
        { key: "acoes", label: "Ações", class: "w100-field" },
      ],
    };
  },
  methods: {
    doShowPlanejOriginal() {
      this.$bvModal.show("modal-planej-original");
    },
    doShowGerarInicial() {
      this.inicial.meses = this.wbs.prazo_meses;
      if ((this.wbs.dt_os || "") != "") {
        this.inicial.data1 = moment(this.wbs.dt_os)
          .add(40, "days")
          .format("YYYY-MM-DD");
        this.$bvModal.show("modal-gerar-inicial");
      } else {
        axios
          .post(`${baseApiUrl}/bid/cronograma/tarefaos`, {
            programa_id: this.wbs.programa_id,
            wbs_id: this.wbs.wbs_id,
          })
          .then((resp) => {
            if (resp.data) this.inicial.data1 = resp.data.dt_inicio;

            this.$bvModal.show("modal-gerar-inicial");
          })
          .catch((ex) => {
            showError(ex);
            console.log(ex);
          });
      }
    },
    deleteAll() {
      this.$bvModal
        .msgBoxConfirm(`Excluir todos os registros?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(
                `${baseApiUrl}/bid/resumo-financeiro/${this.wbs.programa_id}/${this.wbs.wbs_id}`
              )
              .then(() => {
                this.showResumo();
              })
              .catch((err) => {
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    doAddResumo() {
      this.registro = new resumoModel();
      this.registro.programa_id = this.wbs.programa_id;
      this.registro.wbs_id = this.wbs.wbs_id;
      this.acaoRegistro = "incluir";
      this.$bvModal.show("modal-resumo");
    },
    showObsResumo(item) {
      this.registro = { ...item };
      this.$bvModal.show("modal-obs-resumo");
    },
    editResumo(item) {
      this.registro = { ...item };
      this.acaoRegistro = "alterar";
      this.$bvModal.show("modal-resumo");
    },
    deleteResumo(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir o Planejamento [${item.resumo_id}]?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(`${baseApiUrl}/bid/resumo-financeiro/${item.resumo_id}`)
              .then(() => {
                this.showResumo();
              })
              .catch((err) => {
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    doRedistribuir() {
      let _params = {
        programa_id: this.wbs.programa_id,
        wbs_id: this.wbs.wbs_id,
      };
      this.isRedistributing = true;
      axios
        .post(`${baseApiUrl}/bid/resumo-financeiro/redistribuir`, _params)
        .then(() => {
          this.showResumo();
          this.isRedistributing = false;
        });
    },
    doGerarInicial() {
      if (this.inicial.meses == null || this.inicial.meses == 0) {
        this.$toasted.global.warning({
          msg: "Qtde de Meses Inválido!",
        });
        return;
      }

      if (!validateDate(this.inicial.data1, "YYYY-MM-DD")) {
        this.$toasted.global.warning({
          msg: "Data do 1º Faturamento Inválida!",
        });

        return;
      }

      this.$bvModal
        .msgBoxConfirm(`Confirma a geração?`, {
          noFade: true,
          okTitle: "Gerar",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            let _valor = this.wbs.vl_total_reajustes || 0;
            if (_valor == 0) _valor = this.wbs.vl_inicial_contrato || 0;
            if (_valor == 0) _valor = this.wbs.vl_estimado_licitacao || 0;

            let _params = {
              meses: this.inicial.meses,
              data1: this.inicial.data1,
              programa_id: this.wbs.programa_id,
              wbs_id: this.wbs.wbs_id,
              valor_inicial: _valor,
            };
            axios
              .post(`${baseApiUrl}/bid/resumo-financeiro/gerar`, _params)
              .then((resp) => {
                this.resumo = resp.data;
                this.gerarAcumulados();
              });
          }
        });
    },
    gerarAcumulados() {
      // limpar antes
      this.resumo.forEach((element) => {
        element.vl_planejado_orig_ac = 0;
        element.vl_planejado_ac = 0;
        element.vl_pago_ac = 0;
        element.vl_medido_ac = 0;
        element.vl_saldo_pagar_ac = 0;
        element.vl_saldo_reconhecer_ac = 0;

        element.vl_planejado_orig_m2_ac = 0;
        element.vl_planejado_m2_ac = 0;
        element.vl_pago_m2_ac = 0;
        element.vl_medido_m2_ac = 0;
        element.vl_saldo_pagar_m2_ac = 0;
        element.vl_saldo_reconhecer_m2_ac = 0;

        element.vl_reconhecido_ac = 0;
        element.vl_reconhecido_m2_ac = 0;

        //perc. acumulados
        element.perc_planejado_ac = 0;
        element.perc_medido_ac = 0;
        element.perc_pago_ac = 0;
        element.perc_reconhecido_ac = 0;
      });

      if (this.resumo.length > 0) {
        //acumulados
        let vl_planejado_orig_ac = parseFloat(0);
        let vl_planejado_ac = parseFloat(0);
        let vl_pago_ac = parseFloat(0);
        let vl_reconhecido_ac = parseFloat(0);
        let vl_medido_ac = parseFloat(0);

        // moeda 2
        let vl_planejado_orig_m2_ac = parseFloat(0);
        let vl_planejado_m2_ac = parseFloat(0);
        let vl_pago_m2_ac = parseFloat(0);
        let vl_medido_m2_ac = parseFloat(0);
        let vl_reconhecido_m2_ac = parseFloat(0);

        //perc acumulados
        let perc_planejado_ac = parseFloat(0);
        let perc_medido_ac = parseFloat(0);
        let perc_pago_ac = parseFloat(0);
        let perc_reconhecido_ac = parseFloat(0);

        this.resumo.forEach((element) => {
          vl_planejado_orig_ac += parseFloat(element.vl_planejado_orig);
          vl_planejado_ac += parseFloat(element.vl_planejado);
          vl_pago_ac += parseFloat(element.vl_pago);
          vl_medido_ac += parseFloat(element.vl_medido);
          vl_reconhecido_ac += parseFloat(element.vl_reconhecido);

          vl_planejado_orig_m2_ac += parseFloat(element.vl_planejado_orig_m2);
          vl_planejado_m2_ac += parseFloat(element.vl_planejado_m2);
          vl_pago_m2_ac += parseFloat(element.vl_pago_m2);
          vl_medido_m2_ac += parseFloat(element.vl_medido_m2);
          vl_reconhecido_m2_ac += parseFloat(element.vl_reconhecido_m2);

          perc_planejado_ac =
            (vl_planejado_ac / this.divZero(this.wbs.vl_total_reajustes)) * 100;
          perc_medido_ac =
            (vl_medido_ac / this.divZero(this.wbs.vl_total_reajustes)) * 100;

          perc_pago_ac =
            (vl_pago_ac / this.divZero(this.wbs.vl_total_reajustes)) * 100;

          perc_reconhecido_ac =
            (vl_reconhecido_ac / this.divZero(this.wbs.vl_total_reajustes)) *
            100;

          element.vl_planejado_orig_ac = vl_planejado_orig_ac;
          element.vl_planejado_ac = vl_planejado_ac;
          element.vl_pago_ac = vl_pago_ac;
          element.vl_medido_ac = vl_medido_ac;
          element.vl_reconhecido_ac = vl_reconhecido_ac;
          element.vl_saldo_pagar_ac = vl_medido_ac - vl_pago_ac;
          element.vl_saldo_reconhecer_ac = vl_pago_ac - vl_reconhecido_ac;

          element.vl_planejado_orig_m2_ac = vl_planejado_orig_m2_ac;
          element.vl_planejado_m2_ac = vl_planejado_m2_ac;
          element.vl_pago_m2_ac = vl_pago_m2_ac;
          element.vl_medido_m2_ac = vl_medido_m2_ac;
          element.vl_reconhecido_m2_ac = vl_reconhecido_m2_ac;
          element.vl_saldo_pagar_m2_ac = vl_medido_m2_ac - vl_pago_m2_ac;
          element.vl_saldo_reconhecer_m2_ac =
            vl_pago_m2_ac - vl_reconhecido_m2_ac;
          element.perc_planejado_ac = perc_planejado_ac;
          element.perc_medido_ac = perc_medido_ac;
          element.perc_pago_ac = perc_pago_ac;
          element.perc_reconhecido_ac = perc_reconhecido_ac;
        });
      }
      this.isLoading = false;
    },
    showResumo() {
      this.isLoading = true;
      this.resumo = [];
      axios
        .get(`${baseApiUrl}/bid/resumo-financeiro/listar`, {
          params: {
            programa_id: this.wbs.programa_id,
            wbs_id: this.wbs.wbs_id,
            sintetico: 0,
          },
        })
        .then((resp) => {
          this.resumo = resp.data;
          this.gerarAcumulados();
        })
        .catch((ex) => {
          this.isLoading = false;
          showError(ex);
        });
    },
    divZero(value) {
      return (value || 0) == 0 ? 1 : value;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.ind_medido) return "table-danger";
      if ((item.vl_pago || 0) > 0) return "table-success";
    },
  },
  created() {
    bidbus.$on("refreshResumo", () => {
      this.showResumo();
    });
  },
  mounted() {
    this.showResumo();
  },
};
</script>

<style>
.top-header th {
  background-color: #4c545b !important;
  text-align: center;
  border-bottom: none !important;
}

.table-header th {
  border-color: #aaa !important;
}

.accum-col {
  background-color: #efefef;
}

.accum-col:hover {
  color: #333 !important;
}

.table-border td {
  border-color: #ccc !important;
}
</style>
